import api from './api';

// Dashboard
export const getBenefitDashboard = () =>
  api.get('/v1/benefit-dashboard');

// Reports — each returns a PaginatedList
export const getBenefitCostByCategory = (params) =>
  api.get('/v1/benefit-reports/cost-by-category', { params });

export const getBenefitCostByDepartment = (params) =>
  api.get('/v1/benefit-reports/cost-by-department', { params });

export const getBenefitEnrollment = (params) =>
  api.get('/v1/benefit-reports/enrollment', { params });

export const getBenefitDependentDemographics = (params) =>
  api.get('/v1/benefit-reports/dependent-demographics', { params });

export const getBenefitCafeteriaUtilization = (params) =>
  api.get('/v1/benefit-reports/cafeteria-utilization', { params });

export const getBenefitApplicationSla = (params) =>
  api.get('/v1/benefit-reports/application-sla', { params });

export const getBenefitLifeEventThroughput = (params) =>
  api.get('/v1/benefit-reports/life-event-throughput', { params });

export const getBenefitPiiExport = (params) =>
  api.get('/v1/benefit-reports/pii-export', { params });

// Unified XLSX export
export const exportBenefitReport = (reportType, params) =>
  api.get(`/v1/benefit-reports/${reportType}/export`, {
    params,
    responseType: 'blob',
  });

// Audit logs
export const getBenefitAuditLogs = (params) =>
  api.get('/v1/benefit-audit-logs', { params });

export const getBenefitAuditLog = (id) =>
  api.get(`/v1/benefit-audit-logs/${id}`);
